/**
 *
 */
export default class VentaVehiculos {
  name = '';
}
